export default {
  DESKTOP_LG: 1440,
  DESKTOP: 1240,
  TABLET: 768,
  PHONE: 376,
};
